import { IFilterComplete } from '../../filter-complete/filter-complete';

export class SexFilter implements IFilterComplete {
    Name: string;
    Id: number;
}
